/**
 * Generate test id function helper.
 * @param { TestIdContext } props
 * @returns { generateTestId~generateTestIdFunction } Function that returns testId
 */
export default function generateTestId(_ref) {
  var team = _ref.team,
      project = _ref.project;
  var prefix = "".concat(team, "-").concat(project ? "".concat(project, "-") : '');
  /**
   * @callback generateTestId~generateTestIdFunction
   * @param {string} testId - component name
   * @returns { string }
   */

  return function (testId) {
    return "".concat(prefix).concat(testId);
  };
}